import './instrument';
import './i18n';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import './index.css';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';
import { Toaster } from './components/ui/sonner.tsx';
import { KeycloakProvider } from './context/KeycloakContext.tsx';
import { ThemeProvider } from './context/ThemeContext.tsx';
import { router } from './routes/root.ts';
import { queryClient } from './queries/query.client.ts';

const rootElement = document.getElementById('root') as HTMLElement;
const root = createRoot(rootElement);

root.render(
	<StrictMode>
		<ErrorBoundary>
			<Toaster position="bottom-right" richColors expand />
			<KeycloakProvider>
				<QueryClientProvider client={queryClient}>
					<ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
						<RouterProvider router={router} />
						<ReactQueryDevtools initialIsOpen={false} />
					</ThemeProvider>
				</QueryClientProvider>
			</KeycloakProvider>
		</ErrorBoundary>
	</StrictMode>,
);
